import { Outlet } from 'react-router-dom'

export function AuthLayout() {
  return (
    <div className="flex min-h-screen">
      <div className="hidden w-1/2 flex-col justify-between bg-gradient-to-br from-indigo-600 via-indigo-700 to-slate-900 p-12 text-white lg:flex">
        <div className="flex items-center gap-3">
          <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-white/20 text-lg font-bold">
            P
          </div>
          <span className="text-xl font-bold">Partner Portal</span>
        </div>
        <div className="max-w-md space-y-4">
          <h1 className="text-4xl font-bold leading-tight tracking-tight">
            Manage your partner ecosystem with confidence
          </h1>
          <p className="text-lg text-indigo-100">
            Track leads, close deals, manage users, and configure payment
            gateways — all from one enterprise-grade dashboard.
          </p>
        </div>
        <p className="text-sm text-indigo-200">
          Trusted by 500+ partners worldwide
        </p>
      </div>
      <div className="flex flex-1 items-center justify-center bg-background p-6">
        <div className="w-full max-w-md">
          <Outlet />
        </div>
      </div>
    </div>
  )
}
